export const ADD_EXPENSE = 'ADD_EXPENSE';
export const DELETE_EXPENSE = 'DELETE_EXPENSE';
export const GET_EXPENSES = 'GET_EXPENSES';
export const ADD_RECURRING_EXPENSE = 'ADD_RECURRING_EXPENSE';
export const GET_RECURRING_EXPENSES = 'GET_RECURRING_EXPENSES';
export const DELETE_RECURRING_EXPENSE = 'DELETE_RECURRING_EXPENSE';

export const ADD_INCOME = 'ADD_INCOME';
export const DELETE_INCOME = 'DELETE_INCOME';
export const GET_INCOME = 'GET_INCOME';
export const ADD_RECURRING_INCOME = 'ADD_RECURRING_INCOME';
export const GET_RECURRING_INCOME = 'GET_RECURRING_INCOME';
export const DELETE_RECURRING_INCOME = 'DELETE_RECURRING_INCOME';

export const TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE';
export const SET_LANGUAGE = 'SET_LANGUAGE';